"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axiosClient_1 = require("../axiosClient");
const BundleAPI = {
    makeBaseURI() {
        return `/v2/operators/bundles`;
    },
    list() {
        return axiosClient_1.client.get(`${BundleAPI.makeBaseURI()}`);
    },
    listOperatorsForBundle(bundleName) {
        return axiosClient_1.client.get(`${BundleAPI.makeBaseURI()}?bundle_name=${bundleName}`);
    },
};
exports.default = BundleAPI;
//# sourceMappingURL=BundleAPI.js.map